module.exports = __webpack_public_path__ + "img/lg_ring_y_s_0_1@2x.324b85c5.png";